





























import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseHeading',
  props: {
    level: {
      type: Number,
      default: 2,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  data(...args): any {
    return args;
  },
  // @ts-ignore migrated from ui-library
  hasDescription(descriptionProp, slots) {
    return !!descriptionProp || slots().description;
  },
  // @ts-ignore migrated from ui-library
  headingClass(headingLevel) {
    return headingLevel <= 6 ? `h${headingLevel}` : `h2`;
  },
});
